import {environment} from './environment';
import {environment_dev} from './env/environment.dev';
import {environment_test} from './env/environment.test';
import {environment_uat} from './env/environment.uat';
import {environment_prod} from './env/environment.prod';
//import { environment_local } from './env/environment.local';

export class AppConfig {

	public static setup() {
		const fields = ['production', 'name', 'override', 'api', 'serverUrl', 'okta', 'authentication', 'qar', 'url', 'issuer', 'redirectUri', 'loginUri', 'clientId', 'pkce'];
		let fromEnv = {};
		switch (location.hostname) {
			
			//case 'qarsod.local.hcch.com':
				
			//	fromEnv = environment_local;
			//	break;
			case 'dev.qarportal.tmhcc.com':
				fromEnv = environment_dev;
				break;
			case 'qa.qarportal.tmhcc.com':
				fromEnv = environment_test;
				break;
			case 'uat.qarportal.tmhcc.com':
				fromEnv = environment_uat;
				break;
			case 'qarportal.tmhcc.com':
				fromEnv = environment_prod;
				break;
		}

		for (const k of Object.keys(fromEnv)) {
			environment[k] = fromEnv[k];
		}
		console.log('AppConfig', location.hostname, environment.name);
	}
}
